import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import Modal from 'components/_molecules/Modal'

import Map from 'components/Map'
import EventSummaryModal from 'components/EventSummaryModal'
import EventInfo from 'components/EventInfo'
import StartTripControls from 'components/StartTripControls'
import PushPinIcon from 'components/icons/PushPin'
import AddTripScene from './AddTripScene'
import EditTripScene from './EditTripScene'
import { renderTripPageHelmet, } from 'lib/pageHelmet'

class TripScene extends Component {
  static propTypes = {
    appMode: PropTypes.string.isRequired,
    selectedTripData: PropTypes.shape({
      events: PropTypes.array,
    }),
    selectedTripId: PropTypes.string,
    selectedEventData: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    selectedEventInfoDisplayed: PropTypes.bool,
    selectedEventNextEventId: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    selectedEventNextEvent: PropTypes.object,
    selectedEventPreviousEventId: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    selectedEventPreviousEvent: PropTypes.object,
    actions: PropTypes.shape({
      navViewTrip: PropTypes.func.isRequired,
      navViewEvent: PropTypes.func.isRequired,
      navViewEventInfo: PropTypes.func.isRequired,
    }).isRequired,
    addingTrip: PropTypes.bool,
    editingTrip: PropTypes.bool,
    currentEventId: PropTypes.string,
  }

  static defaultProps = {
    selectedTripData: {
      events: [],
    },
    selectedTripId: undefined,
    selectedEventData: undefined,
    selectedEventInfoDisplayed: false,
    selectedEventNextEventId: undefined,
    selectedEventNextEvent: undefined,
    selectedEventPreviousEventId: undefined,
    selectedEventPreviousEvent: undefined,
    addingTrip: false,
    editingTrip: false,
    currentEventId: undefined,
  }

  state = {
    selectedEvent: undefined,
  }

  onShowEventSummary = ({ eventId, }) => {
    this.props.actions.navViewEvent({
      tripId: this.props.selectedTripId,
      eventId,
    })
  }

  onShowEventInfo = () => {
    this.props.actions.navViewEventInfo({
      tripId: this.props.selectedTripId,
      eventId: this.props.selectedEventData.id,
    })
  }

  onHideEventInfo = () => {
    this.props.actions.navViewEvent({
      tripId: this.props.selectedTripId,
      eventId: this.props.selectedEventData.id,
    })
  }

  onStartTrip = () => {
    const { selectedTripData, } = this.props
    this.goToEvent({ eventId: selectedTripData.events[0].id, })
  }

  onGoToCurrentLocation = () => {
    const { currentEventId, } = this.props
    this.goToEvent({ eventId: currentEventId, })
  }

  viewTrip = () => {
    this.props.actions.navViewTrip({ tripId: this.props.selectedTripId, })
  }

  goToEvent = ({ eventId, }) => {
    const { selectedTripId: tripId, selectedEventInfoDisplayed, } = this.props
    if (selectedEventInfoDisplayed) {
      this.props.actions.navViewEventInfo({ tripId, eventId, })
    } else {
      this.props.actions.navViewEvent({ tripId, eventId, })
    }
  }

  goToNextEvent = () => {
    const { selectedEventNextEventId: eventId, } = this.props
    this.goToEvent({ eventId, })
  }

  goToPreviousEvent = () => {
    const { selectedEventPreviousEventId: eventId, } = this.props
    this.goToEvent({ eventId, })
  }

  render() {
    const {
      onShowEventSummary,
      viewTrip,
      onShowEventInfo,
      onHideEventInfo,
      onStartTrip,
      goToNextEvent,
      goToPreviousEvent,
      onGoToCurrentLocation,
    } = this
    const {
      selectedTripData,
      selectedEventData,
      selectedEventNextEventId,
      selectedEventNextEvent,
      selectedEventPreviousEventId,
      selectedEventPreviousEvent,
      selectedEventInfoDisplayed,
      addingTrip,
      editingTrip,
      currentEventId,
    } = this.props

    let centerLatLng
    let eventSummary
    let eventInfo
    if (selectedEventData) {
      centerLatLng = {
        lat: selectedEventData.lat,
        lng: selectedEventData.lng,
      }
      eventSummary = {
        event: {
          name: selectedEventData.name,
        },
        hasPreviousEvent: !!selectedEventPreviousEventId,
        hasNextEvent: !!selectedEventNextEventId,
        eventInfoDisplayed: false,
        goToPreviousEvent,
        goToNextEvent,
        close: viewTrip,
        showEventInfo: onShowEventInfo,
        backgroundMode: !!selectedEventInfoDisplayed,
      }
      eventInfo = {
        event: selectedEventData,
        previousEvent: selectedEventPreviousEvent,
        nextEvent: selectedEventNextEvent,
        close: onHideEventInfo,
        hasNextEvent: !!selectedEventNextEvent,
        hasPreviousEvent: !!selectedEventPreviousEvent,
        goToNextEvent,
        goToPreviousEvent,
      }
    }

    const showZoomControls =
      !selectedEventInfoDisplayed && !addingTrip && !editingTrip

    const mapSetup = {
      defaultCenterUserLocation: false,
      defaultCenter: { lat: 7.290571, lng: 80.63372, },
      initialZoom: 7,
      minZoom: 2,
      showZoomControls,
    }

    const showEventSummary = !!selectedEventData

    const eventsToDisplay = addingTrip ? [] : selectedTripData.events
    const hasCurrentLocation = !!currentEventId

    let selectedEventTitle = ''
    if (selectedEventData && currentEventId === selectedEventData.id) {
      selectedEventTitle = (
        <div>
          {' '}
          <PushPinIcon fill="white" /> {selectedEventData.name}{' '}
        </div>
      )
    } else if (selectedEventData) {
      selectedEventTitle = selectedEventData.name
    }

    const managingTrip = (editingTrip || addingTrip)

    return (
      <div data-component="TripScene">

        {renderTripPageHelmet({
          managingTrip,
          viewingTripEvent: selectedEventInfoDisplayed,
          eventName: selectedEventData ? selectedEventData.name : null,
          tripName: selectedTripData.name,
        })}

        <Map
          events={eventsToDisplay}
          onEventSelected={onShowEventSummary}
          currentEventId={currentEventId}
          centerLatLng={centerLatLng}
          setup={mapSetup}
        />
        {!selectedEventInfoDisplayed &&
        !showEventSummary &&
        !editingTrip &&
        !addingTrip && (
          <StartTripControls
            startTrip={onStartTrip}
            hasCurrentLocation={hasCurrentLocation}
            goToCurrentLocation={onGoToCurrentLocation}
          />
        )}
        <EventSummaryModal
          isOpen={showEventSummary}
          onRequestClose={viewTrip}
          eventSummary={eventSummary}
        />
        <Modal
          isOpen={selectedEventInfoDisplayed}
          modalTitle={selectedEventTitle}
          onRequestClose={onHideEventInfo}
        >
          {selectedEventInfoDisplayed && <EventInfo {...eventInfo} />}
        </Modal>
        <Modal
          isOpen={editingTrip}
          modalTitle="Edit Trip"
          onRequestClose={viewTrip}
        >
          <EditTripScene />
        </Modal>
        <Modal
          isOpen={addingTrip}
          modalTitle="Add Trip"
          onRequestClose={viewTrip}
        >
          <AddTripScene />
        </Modal>
      </div>
    )
  }
}

export default TripScene



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripScene/component.js